var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiLinkedinFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72664 4.38286C5.72642 4.80748 5.55754 5.21463 5.25713 5.51474C4.95673 5.81484 4.54941 5.98332 4.12479 5.98311C3.70016 5.98289 3.29301 5.81401 2.99291 5.5136C2.6928 5.2132 2.52432 4.80588 2.52454 4.38126C2.52475 3.95663 2.69363 3.54948 2.99404 3.24938C3.29444 2.94927 3.70176 2.78079 4.12639 2.78101C4.55101 2.78122 4.95816 2.9501 5.25827 3.25051C5.55837 3.55091 5.72685 3.95823 5.72664 4.38286ZM5.77467 7.16868H2.57257V17.1913H5.77467V7.16868ZM10.834 7.16868H7.6479V17.1913H10.802V11.9318C10.802 9.00189 14.6205 8.72971 14.6205 11.9318V17.1913H17.7825V10.8431C17.7825 5.90385 12.1308 6.08797 10.802 8.51357L10.834 7.16868Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiLinkedinFill);
export default __webpack_public_path__ + "static/media/ri_linkedin-fill.e9ef5e176d395f26640d9f74f8197083.svg";
export { ForwardRef as ReactComponent };